import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { RECRUITEE_THEME_DEFAULT, ThemeUtilsService } from '@recruitee/theme';

import { environment } from '../environments/environment';
import { AccountSetupBundles } from './account-setup-bundles.service';

@Component({
  selector: 'rto-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent {
  public loading: boolean = true;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private router: Router,
    protected cdRef: ChangeDetectorRef,
    private accountSetupBundles: AccountSetupBundles,
  ) {
    ThemeUtilsService.setThemeHTMLData(RECRUITEE_THEME_DEFAULT);
  }

  public ngOnInit(): void {
    if (environment.analytics) {
      this.loadGrowsumo();
    } else {
      // TODO remove after testing
      (<any>window).loadGrowsumo = this.loadGrowsumo.bind(this);
    }
  }

  private loadGrowsumo(): void {
    const growsumoBundle = this.accountSetupBundles.create({
      name: 'growsumo',
      url: 'https://snippet.growsumo.com/growsumo.min.js',
    });

    growsumoBundle
      .load()
      .pipe(
        filter(status => status.loaded),
        takeUntil(this.ngOnDestroy$.asObservable()),
      )
      .subscribe(() => {
        const growsumo = (<any>window).growsumo;
        growsumo._initialize(environment.growsumoPublicKey);
      });
  }
}
